export enum WhatsAppMediaType {
    // Images
    IMAGE_JPEG = "image/jpeg",
    IMAGE_PNG = "image/png",
    IMAGE_GIF = "image/gif",

    // Video
    VIDEO_MP4 = "video/mp4",
    VIDEO_3GPP = "video/3gpp",

    // Audio
    AUDIO_AAC = "audio/aac",
    AUDIO_MPEG = "audio/mpeg",   // MP3
    AUDIO_AMR = "audio/amr",
    AUDIO_OGG = "audio/ogg",     // Often "audio/ogg; codecs=opus"

    // Documents
    APPLICATION_PDF = "application/pdf",
    APPLICATION_MSWORD = "application/msword", // .doc
    APPLICATION_DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    APPLICATION_XLS = "application/vnd.ms-excel",
    APPLICATION_XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    APPLICATION_PPT = "application/vnd.ms-powerpoint",
    APPLICATION_PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation",

    // Text
    TEXT_PLAIN = "text/plain",
    TEXT_CSV = "text/csv",
}

export interface ConversationMessage {
    id?: number;
    conversationId?: number;
    externalId: string;
    content: string;
    imageUrl?: string;
    time: Date;
    status?: string;
    errorMessage?: string;
    sentByClient: boolean;
    senderType?: string | null;
    sourceType?: string | null;
    metadataJson?: any;
    messageHistoryId?: number;
    fromName?: string;
    shop: string;
    createdAt: Date;
    media?: {
        contentType: WhatsAppMediaType;
        url: string;
    }[]
}
